import { Download, X, Share } from "lucide-react";

export function BannerInstalarGeneral({ ios, onInstalar, onCerrar }) {
  return (
    <div
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[60] w-[calc(100%-2rem)] max-w-md rounded-2xl border border-sky-200 bg-white/95 backdrop-blur shadow-xl shadow-sky-900/10 p-4 flex items-start gap-3"
      data-testid="pwa-install-banner"
    >
      <div className="flex-shrink-0 w-11 h-11 rounded-xl bg-[#0A2540] flex items-center justify-center">
        <Download className="w-5 h-5 text-sky-300" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-heading font-bold text-[#034694] text-sm">Instala NuvliPro en tu móvil</p>
        {ios ? (
          <p className="text-xs text-slate-600 mt-0.5 flex items-center gap-1">
            Pulsa <Share className="w-3.5 h-3.5 inline" /> y luego "Añadir a pantalla de inicio".
          </p>
        ) : (
          <>
            <p className="text-xs text-slate-600 mt-0.5">Accede como una app, sin abrir el navegador.</p>
            <button
              onClick={onInstalar}
              className="mt-2 inline-flex items-center gap-1.5 rounded-lg bg-[#0A2540] hover:bg-[#031B33] text-white text-xs font-semibold px-3 py-1.5 transition-colors"
              data-testid="pwa-install-button"
            >
              <Download className="w-3.5 h-3.5" /> Instalar app
            </button>
          </>
        )}
      </div>
      <button onClick={onCerrar} className="flex-shrink-0 p-1 text-slate-400 hover:text-slate-600" data-testid="pwa-install-dismiss" aria-label="Cerrar">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
